import { useCallback } from "react";
import { defaultOptions, useIntlInstance } from "./useIntlInstance";

/**
 * Returns a memoized date formatter function that formats dates according to the specified options.
 *
 * @warning Only the initial options will be used. Subsequent changes to the options object will not be reflected in the formatter function.
 */
export function useFormatDate(
  options: Intl.DateTimeFormatOptions = defaultOptions
): (date: string | Date) => string {
  const intlInstance = useIntlInstance(options);

  const formatter = useCallback(
    (dateArg: string | Date) => {
      const dateFormatter = intlInstance.format;
      try {
        const date = dateArg instanceof Date ? dateArg : new Date(dateArg);
        return dateFormatter(date);
      } catch {
        return "";
      }
    },
    [intlInstance]
  );
  return formatter;
}
